import React, { useState, useEffect, useRef } from 'react';
import './FormPage.css';
import logo from '../Image/image.png';
import coaching from '../Image/SwimmingCoaching.png';
import playing from '../Image/SwimmingPlaying.png';
import video from '../Image/Testimonial.png';
import Lottie from "lottie-react";
import successAnimation from "../success.json";
import UserImage from '../Image/dummyimage.png';
import 'react-image-crop/dist/ReactCrop.css';
import domtoimage from 'dom-to-image';
import Swal from 'sweetalert2';
import female from '../Image/Testimonial.png';
import male from '../Image/Testimonial.png';
import { useNavigate } from 'react-router-dom';

const testimonials = [
  {
    video: video,
    text: "Whether I'm training for a marathon or just staying active, it helps me push my limits and stay on top of my fitness goals.",
    name: "Prithviraj Singh Hada",
  },
  {
    video: video,
    text: "Whether I'm training for a marathon or just staying active, it helps me push my limits and stay on top of my fitness goals.",
    name: "Prithviraj Singh Hada",
  },
  {
    video: video,
    text: "Whether I'm training for a marathon or just staying active, it helps me push my limits and stay on top of my fitness goals.",
    name: "Prithviraj Singh Hada",
  },
];

const FormPage = () => {
  const navigate = useNavigate();
  const [name, setName] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [storedName, setStoredName] = useState('');
  const [errors, setErrors] = useState({ name: '', phoneNumber: '' });
  const [gender, setGender] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [showAnimation, setShowAnimation] = useState(false);
  const [totalUsers, setTotalUsers] = useState(0);
  const [pledgeCount, setPledgeCount] = useState(0);
  const saveUserDataUrl = process.env.REACT_APP_SAVE_USER_DATA;
  const getSummerOf2025Url = process.env.REACT_APP_GET_SUMMER_2025;
  const apiKey = process.env.REACT_APP_API_KEY;
  const [badgeDataUrl, setBadgeDataUrl] = useState(null);

  useEffect(() => {
    const userId = localStorage.getItem('userId');
    const savedName = userId ? localStorage.getItem(`userName_${userId}`) : localStorage.getItem("userName");
    if (savedName) {
      setStoredName(savedName);
      setSubmitted(true);
    }
  }, []);

  const validateForm = () => {
    let valid = true;
    let newErrors = { name: '', phoneNumber: '', gender: '' };

    if (!name.trim()) {
      newErrors.name = 'Name is required';
      valid = false;
    }

    const phoneRegex = /^[0-9]{10}$/;
    if (!phoneRegex.test(phoneNumber)) {
      newErrors.phoneNumber = 'Enter a valid 10-digit phone number';
      valid = false;
    }
    setErrors(newErrors);
    return valid;
  };


  const handleSubmit = async (event) => {
    event.preventDefault();

    if (validateForm()) {

      let userId = localStorage.getItem("userId");
      if (!userId) {
        userId = Date.now().toString();
        localStorage.setItem("userId", userId);
      }
      if (croppedImageUrl) {
        localStorage.setItem(`userImage_${userId}`, croppedImageUrl);
      }
      localStorage.setItem(`userName_${userId}`, name);
      setStoredName(name);

      const requestData = {
        name: name,
        mobileNumber: `+91${phoneNumber}`,
      };

      try {
        const response = await fetch(saveUserDataUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "x-api-key": apiKey,
          },
          body: JSON.stringify(requestData),
        });
        if (response.status === 200) {
          navigate('/thankyou', { 
            state: { 
              gender: gender,
              name: name,
              phoneNumber: phoneNumber
            } 
          });
        } else {
          console.error("Failed to send data:", response.statusText);
        }

      } catch (error) {
        console.error("Error sending data:", error);
      }
      setSubmitted(true);
    }
  };

  useEffect(() => {
    const userId = localStorage.getItem('userId');
    const savedName = userId ? localStorage.getItem(`userName_${userId}`) : localStorage.getItem("userName");
    const savedImage = userId ? localStorage.getItem(`userImage_${userId}`) : localStorage.getItem("userImage");
    const savedBadge = localStorage.getItem("userBadge");

    if (savedName) {
      setStoredName(savedName);
      setSubmitted(true);
    }

    if (savedImage) {
      setCroppedImageUrl(savedImage);
    }

    if (savedBadge) {
      setBadgeDataUrl(savedBadge);
    }

  }, []);

  const drawBadge = () => {
    const badgeElement = document.querySelector('.badge-container');

    if (!badgeElement) {
      console.error('Badge container not found!');
      return;
    }

    document.fonts.ready.then(() => {
      setTimeout(() => {
        domtoimage.toBlob(badgeElement, {
          quality: 1,
          bgcolor: null,
          style: { 'background-color': 'transparent' }
        })
          .then((blob) => {
            // Convert blob to base64 for persistent storage
            const reader = new FileReader();
            reader.onloadend = () => {
              const base64Data = reader.result;
              setBadgeDataUrl(base64Data);
              localStorage.setItem("userBadge", base64Data);

              // Trigger download
              const link = document.createElement('a');
              link.href = base64Data;
              link.download = 'Summer2025Badge.png';
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
            };
            reader.readAsDataURL(blob);
          })
          .catch(console.error);
      }, 500);
    });
  };


  const handleShare = async () => {
    if (!badgeDataUrl) {
      alert("Please generate the badge first.");
      return;
    }

    try {

      const response = await fetch(badgeDataUrl);
      const blob = await response.blob();
      const file = new File([blob], "Summer2025Badge.png", { type: "image/png" });

      if (navigator.share) {
        try {
          await navigator.share({
            files: [file],
            title: "Summer of 2025 Badge",
            text: "Check out my Summer of 2025 Badge! Join the movement!",
          });
          return;
        } catch (shareError) {
          console.log('User canceled share:', shareError);
        }
      }


    } catch (error) {
      console.error('Sharing error:', error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Please download the first badge before sharing!",
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
      });
    }
  };
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(getSummerOf2025Url, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "x-api-key": apiKey,
          },
        });

        if (!response.ok) {
          throw new Error("Failed to fetch Summer of 2025 data");
        }

        const data = await response.json();
        setTotalUsers(data.TotalUsers);
        setPledgeCount(data.pledgeCount);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  const [croppedImageUrl, setCroppedImageUrl] = useState(null);


  return (
    <div className="form-page">

      <div className="header-section">
        <img src={logo} alt="Machaxi Logo" className="logo" />
        <h2 className='thank-heading'>25% of Bangalore is Already Diving In – Are You In?</h2>
      </div>

      <div className="statistics-section-form">
      <div className="form-section">
          <>
            <p className="form-heading">
              Make a Splash!   <br />
              Pledge Today & Enjoy 1 FREE Swimming Session!
            </p>
            <form onSubmit={handleSubmit} className="form-fill">

              <div className="input-container">
                <input
                  type="text"
                  className={`form-input ${name ? "active" : ""}`}
                  value={name}
                  onChange={(e) => {
                    let value = e.target.value.slice(0, 30);
                    if (value.length > 0) {
                      value = value.charAt(0).toUpperCase() + value.slice(1);
                    }
                    setName(value);
                  }}
                  required
                />
                <label className="floating-placeholder">First Name</label>
              </div>


              <div className="input-container">
                <input
                  type="text"
                  className={`form-input ${phoneNumber ? "active" : ""}`}
                  value={phoneNumber}
                  onChange={(e) => {
                    const value = e.target.value.replace(/\D/g, "");
                    setPhoneNumber(value);
                  }}
                  required
                  maxLength={10}
                />
                <label className="floating-placeholder">Phone Number</label>
              </div>

              <div className="input-container">
              <label >Gender:</label>
              <label style={{ marginRight: '20px', marginLeft: '10px' }}>
                  <input
                    type="radio"
                    name="gender"
                    value="male"
                    checked={gender === 'male'}
                    onChange={(e) => setGender(e.target.value)}
                    className='gender'
                  />
                  Male
                </label>
                <label>
                  <input
                    type="radio"
                    name="gender"
                    value="female"
                    checked={gender === 'female'}
                    onChange={(e) => setGender(e.target.value)}
                  />
                  Female
                </label>
              </div>
              <button type="submit" className="submit-button">
                Get My Badge
              </button>
            </form>
          </>
      </div>
      </div>

      {/* Explore Plans Section */}
      <div className="explore-section">
        <p className="section-title">Explore Our Plans</p>
        <div className="plans">
          <div className="plan">
            <a href="https://swimming.playing.machaxi.com/" target="_blank" rel="noopener noreferrer">
              <img src={playing} alt="Swimming Playing" className="plan-img" />
            </a>
            <p className="explore-text">Swimming Playing</p>
          </div>
          <div className="line2"></div>
          <div className="plan">
            <a href="https://swimming.coaching.machaxi.com/" target="_blank" rel="noopener noreferrer">
              <img src={coaching} alt="Swimming Coaching" className="plan-img" />
            </a>
            <p className="explore-text">Swimming Coaching</p>
          </div>
        </div>
      </div>


      {/* Testimonials Section */}
      {/* <div className="testimonial-section">
        <h2 className="testimonial-title">What our users have to say</h2>
        <div className="testimonial-container">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="testimonial-card">
              <div className="testimonial-video">
                <img src={testimonial.video} alt="Testimonial" />
                <div className="video-overlay">
                  <button className="play-button">
                    <svg
                      width="50"
                      height="50"
                      viewBox="0 0 24 24"
                      fill="white"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <circle cx="12" cy="12" r="10" stroke="white" strokeWidth="2" fill="transparent" />
                      <polygon points="9,7 9,17 17,12" fill="white" />
                    </svg>
                  </button>
                </div>
              </div>
              <p className="testimonial-para">{testimonial.text}</p>
              <div className="testimonial-name">
                <p className="testimonial-text">{testimonial.name}</p>
              </div>
            </div>
          ))}
        </div>
      </div> */}

    </div>
  );
}

export default FormPage;